import CustomStore from "devextreme/data/custom_store";
import { apiConfiguration } from "../apiConfig";
import { ListiniApi, GetListiniAnimaliRequest } from "../data/apis/ListiniApi";

export function listiniAnimaliDataSource(idFiliera: number, showAll: boolean ) {
    return new CustomStore({
        key: "id",
        loadMode : 'raw',
        load: (loadOptions) => {
            const api = new ListiniApi(apiConfiguration);

            const request: GetListiniAnimaliRequest = {
                idFiliera: idFiliera,
            };

            return api.getListiniAnimali(request);
        },

        byKey: (key) => {
            const api = new ListiniApi(apiConfiguration);

            return api.getListinoAnimaliById({
                idListino: key
            });
        },

        insert: (values) => {
            const api = new ListiniApi(apiConfiguration);

            return api.insertListinoAnimali({
                listinoCreateDTO: values
            });
        },

        update: async (key: any) => {},
        remove: async (key: any) => {},

    });
}